import { Base } from '../../abstract/base.model';
import { EventType } from './event-type.model';
import { ResourceType } from './resource-type.model';
import { isRecord } from '../utils/is-record';
import { countOrZero, nullableBoolean, nullableString } from '../utils/wire-value-utils';

/**
 * One entry of an organization's activity feed, built from the hub's activity JSON
 * (`user-activities-controller.ts`, hub `data-models/organization-activity.ts`).
 *
 * The hub writes activities itself; the web never creates or updates them, so every field is read-only
 * and the display fields have fallbacks. `visibilityRoles` is a bit set of the activity roles
 * (`ROLE_OWNER` … `ROLE_PILOT` in `organization-activity-utils.ts`).
 */
export class OrganizationActivity extends Base {
  organizationId?: string | null;
  profileId: string | null;
  eventType: EventType;
  message: string;
  resourceType: ResourceType | null;
  resourceId: string | null;
  visibilityRoles: number;
  isHighPriority: boolean;

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    this.organizationId = nullableString(source['organizationId']);
    this.profileId = nullableString(source['profileId']) ?? null;
    this.eventType = (nullableString(source['eventType']) ?? '') as EventType;
    this.message = nullableString(source['message']) ?? '';
    this.resourceType = (nullableString(source['resourceType']) ?? null) as ResourceType | null;
    this.resourceId = nullableString(source['resourceId']) ?? null;
    this.visibilityRoles = countOrZero(source['visibilityRoles']);
    this.isHighPriority = nullableBoolean(source['isHighPriority']) ?? false;
  }
}
